import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {getRequest, postRequest} from "../../api";

export const handleSendMobileCode = createAsyncThunk('register/handleSendMobileCode', async({value}, thunkApi) => {
    try{
        const {data} = await postRequest('/coach/register/step/1', { mobile: value.mobile })
        return data
    }
    catch (error){
        console.log(error.response.status)
        return thunkApi.rejectWithValue(error.response)
    }
})

export const handleVerifyCode = createAsyncThunk('register/handleVerifyCode', async({values}, thunkApi) => {
    try{
        const {data} = await postRequest('/coach/register/step/2', { ...values })
        return data
    }
    catch (error){
        console.log(error.response?.data.message)
        return thunkApi.rejectWithValue(error.response?.data.message)
    }
})

export const handleCompleteRegistration = createAsyncThunk('register/handleCompleteRegistration', async(allData, thunkApi) => {
    const {values, history} = allData
    try{
        const {data} = await postRequest('/coach/register/step/3', { ...values })
        return {data, history}
    }
    catch (error){
        return thunkApi.rejectWithValue(error.response?.data.message)
    }
})

export const getProvincesData = createAsyncThunk('register/getProvincesData', async() => {
    try{
        const {data} = await getRequest('/province')
        return data
    }
    catch (error){
        console.error(error)
    }
})

export const getCitiesData = createAsyncThunk('register/getCitiesData', async(id) => {
    try{
        const {data} = await getRequest(`/city?province_id=${id}`)
        return data
    }
    catch (error){
        console.error(error)
    }
})

const registerSlice = createSlice({
    name: 'register',
    initialState: {
        activeStep: 0,
        coachId: 0,
        responseMessage: '',
        errorVerifyCode: false,
        provincesData: [],
        citiesData: [],
    },
    reducers: {
        setResponseMessage: (state, action) => {
            state.responseMessage = action.payload
        },
        handleBackStep: (state, action) => {
            if(state.activeStep !== 0){
                state.activeStep -= 1
            }
        }
    },
    extraReducers(builder){
        builder
            .addCase(handleSendMobileCode.fulfilled, (state, action) => {
                if (action.payload.is_successful) {
                    state.coachId = action.payload.coach_id
                    if (state.activeStep != 2) {
                        state.activeStep += 1
                    }
                }
            })
            .addCase(handleSendMobileCode.rejected, (state, action) => {
                if(action.payload){
                    state.responseMessage = action.payload?.data.message
                }
                if(action.payload?.status === 409){
                    state.activeStep += 2
                }
            });
        builder
            .addCase(handleVerifyCode.fulfilled, (state, action) => {
                if(action.payload.is_successful){
                    state.errorVerifyCode = false
                    if (state.activeStep != 2) {
                        state.activeStep += 1
                    }
                }
                else {
                    state.errorVerifyCode = true
                }
            })
            .addCase(handleVerifyCode.rejected, (state, action) => {
                console.log(action.payload)
                state.responseMessage = action.payload
            });
        builder
            .addCase(handleCompleteRegistration.fulfilled, (state, action) => {
                let history = action.payload.history
                if(action.payload.data?.is_successful){
                    state.responseMessage = action.payload.data?.message
                    setTimeout(() => {
                        history.push('./login')
                    }, 3000)
                }
            })
            .addCase(handleCompleteRegistration.rejected, (state, action) => {
                state.responseMessage = action.payload || 'خطایی رخ داد'
            });
        builder
            .addCase(getProvincesData.fulfilled, (state, action) => {
                state.provincesData = action.payload
            });
        builder
            .addCase(getCitiesData.fulfilled, (state, action) => {
                state.citiesData = action.payload
            })
    }
})

export const {setResponseMessage, handleBackStep} = registerSlice.actions
export const selectActiveStep = state => state.register.activeStep
export const selectCoachId = state => state.register.coachId
export const selectResponseMessage = state => state.register.responseMessage
export const selectErrorVerifyCode = state => state.register.errorVerifyCode
export const selectProvincesData = state => state.register.provincesData
export const selectCitiesData = state => state.register.citiesData

export default registerSlice.reducer